import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { JobAttachmentsService } from 'src/app/core/services/http/attachments/job-attachments.service';
import { TosterService } from 'src/app/core/services/toster/toster.service';
import { FileUploadConfig } from '../../models/file-upload-config.model';
import { FileUploadResponse } from '../../models/file-upload-response.model';
import { Attachment } from '../../models/uploaded-file-list.model';
import { FileService } from '../../services/file.service';
import {  fileUpload } from '../../models/file-upload.model'

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
})
export class FileUploadComponent implements OnInit {
  uploadedFiles: Attachment[] = [];
  files: any[] = [];
  fileData: fileUpload = new fileUpload();
  isExcelFile: boolean = false;
  uploadedFileCount = 0;
  configData: FileUploadConfig;
  deletedFile:Attachment = null;

  @Input() config: FileUploadConfig = new FileUploadConfig();
  @Output() UploadedAttachments = new EventEmitter<Attachment[]>();
  @Output() ScannedAttachments = new EventEmitter<{attachments :Attachment[], files :any []}>();
  @Output() FileForScan = new EventEmitter<any>();
  @Output() DeletededAttachments = new EventEmitter<Attachment>();
  @Input() showImageEditor: boolean;
  @Input() showImageUploader: boolean = true;
  @Input() isEnableScan: boolean = false; 
  @Input() isTradeeAttachment:boolean=false;
  @Input() isScanForAssets: boolean = false;
  @Input() showBeforeAfterTag: boolean = false;
  
  @ViewChild('fileDropRef') fileUploader:ElementRef;
  constructor(
    private jobAttachmentService: JobAttachmentsService,
    private toster: TosterService,
    private fileService: FileService
  ) {}

  ngOnInit(): void {
    this.fileAddEvent();
  }

  ngOnChanges(changes: any): void {
    console.log("this.config",this.config)
    if (changes['config']) {
      this.files = this.config?.files;

      if (this.files?.length > 0) {
        this.addSavedFiles();
        this.setSavedFileStatus();
      }
    }
  }

  onFileDropped($event: any) {
    this.prepareFilesList($event);
  }

  fileBrowseHandler($event: any) {
    this.prepareFilesList($event.target.files);
  }

  private prepareFilesList(files: any[]) {
    if (!this.validate(files)) return;

    this.files.push(...this.convertToFilesList(files));
    var $this = this;
    var documents =  Array.from(files);
    documents.forEach(function(file){
      var fileData =  new fileUpload();
      fileData.File = file;
      fileData.File.isScanForAsset = false;
      if($this.config.excelFileOnly){
        fileData.IsExcelFile = true
      }
    
      $this.upload(fileData);
    });

  }
  
  private upload(fileData: fileUpload) {
    this.emitFileForScan();
    this.markFileUplodingInProgress(fileData.File);
    this.jobAttachmentService.upload(this.appendFile(fileData)).subscribe({
      next: (res) => {
        console.log(res.url)
        this.createUploadedFile(fileData.File, res);
        this.updateFileWithBolbFileName(fileData.File, res);
        this.markFileUploadAsSuccess(fileData.File);
        this.emitUploadedAttachments();
      },
      error: () => {
        this.removeFileOnEror(fileData.File);
      },
    });
  }

  setSavedFileStatus() {
    this.uploadedFileCount = this.files?.length;
  }

  private appendFile(fileData: any): FormData {
    const formData = new FormData();
    if(fileData.IsExcelFile && fileData.IsExcelFile == true){
      formData.append('IsExcelFile','true');
    }else{
      formData.append('IsExcelFile','false');
    }
    
    formData.append('File', fileData.File);
   
    return formData;
  }

  private createUploadedFile(file: any, uploadResponse: FileUploadResponse) {
    let attachment = new Attachment();
    attachment.name = file.name;
    attachment.blobName = uploadResponse.name;
    attachment.blobUrl = uploadResponse.url;
    attachment.isScanForAsset = file.isScanForAsset;
    this.uploadedFiles.push(attachment);
    this.increaseUploadedFileCountByOne();
  }

  private addSavedFiles() {
    this.files.forEach((file) => {
      let attachment = new Attachment();
      attachment.name = file.name;
      attachment.blobName = this.getBlobName(file.url);
      attachment.blobUrl = file.url;
      attachment.comment = file.comment;
      attachment.existing = file.existing;
      attachment.isScanForAsset = file.isScanForAsset;
      this.uploadedFiles.push(attachment);
    });
  }

  private updateFileWithBolbFileName(
    file: any,
    uploadResponse: FileUploadResponse
  ) {
    file.url = uploadResponse.url;
  }

  private markFileUplodingInProgress(file: any) {
    file.isUploading = true;
  }

  private markFileUploadAsSuccess(file: any) {
    file.isUploading = false;
  }

  emitResult() {   
    this.emitUploadedAttachments();
    this.emitFileForScan();  
    if(this.isTradeeAttachment && this.deleteFile!= null)
    this.emitDeletedAttachment();
  }

  emitDeletedAttachment()
  {
    this.DeletededAttachments.emit(this.deletedFile)
  }

  emitUploadedAttachments() {
    if(!this.isEnableScan)
    this.UploadedAttachments.emit(this.uploadedFiles);
    else
    this.ScannedAttachments.emit({attachments : this.uploadedFiles,files :this.files});
    
  }

  emitFileForScan() {
    if (this.config.scanRequired && !this.config.multiple)
      this.FileForScan.emit(this.files[0]);
  }

  removeFileOnEror(errorFile: any) {
    this.files = this.files.filter((file) => file.name != errorFile.name);
  }

  deleteFile(deletedFile: any) {
    this.deletedFile = deletedFile;
    this.uploadedFiles = this.uploadedFiles.filter(
      (file) => file.blobName != this.getBlobName(deletedFile.url)
    );
    this.files = this.files.filter(
      (file) => this.getBlobName(file.url) != this.getBlobName(deletedFile.url)
    );

    this.reduceFilesReadyToUploadCountByOne();
    this.reduceUploadedFileCountByOne();
    this.emitResult();
  }

  private increaseUploadedFileCountByOne() {
    this.uploadedFileCount++;
  }

  reduceUploadedFileCountByOne() {
    this.uploadedFileCount--;
  }
  reduceFilesReadyToUploadCountByOne() {}
  private convertToFilesList(files: any): any[] {
    return Object.keys(files).map((key) => files[key]);
  }

  validate(files: any[]) {
    const filesToValidate = this.convertToFilesList(files);
    
    if (!this.canUploadMultipleFiles(filesToValidate) && this.config.excelFileOnly) {
      this.toster.warning('To re-upload, remove the already uploaded BPAY reference file');
      return false;
    }

    if (!this.canUploadMultipleFiles(filesToValidate)) {
      this.toster.warning('Multiple files upload not allowed...');
      return false;
    }

    if (!this.isEmailOnly(filesToValidate)) {
      this.toster.warning('Only emails can upload...');
      return false;
    }

    if (!this.isAllowedFileType(filesToValidate)) {
      this.toster.warning('File type not supported');
      return false;
    }

    return true;
  }

  private canUploadMultipleFiles(files: any[]) {
    if (!this.config.multiple)
      return files.length == 1 && this.files.length == 0;
    return true;
  }

  isEmailOnly(files: any[]) {
    if (this.config.emailOnly) {
      const allowdFileTypes = EmailFileExtentions.split(',');
      return files.every((file) =>
        allowdFileTypes.some((ext) => ext === this.getFileExtention(file.name))
      );
    }
    return true;
  }

  isAllowedFileType(files: any[]) {
    const allowdFileTypes = this.config.supportedExtensions.split(',');
    return files.every((file) =>
      allowdFileTypes.some(
        (ext) => ext.trim() === this.getFileExtention(file.name)
      )
    );
  }

  getFileExtention(fileName: string) {
    return `.${fileName.split('.').pop()}`.toLowerCase();
  }

  resetFiles(): void {
    this.fileUploader.nativeElement.value = null;
    this.uploadedFiles = [];
    this.files = [];
    this.uploadedFileCount = 0;
    this.emitUploadedAttachments();
  }

  private getBlobName(blobName: string): string {
    return blobName.length > 0 ? blobName.split('net/')[1] : '';
  }

  fileAddEvent() {
    this.fileService.fileAddEvent.subscribe({
      
      next: (result: Attachment) => {
        this.uploadedFiles.push(result);
        this.increaseUploadedFileCountByOne();
        this.files.push({
          name: result.name,
          type: result.extension,
          url: result.blobUrl,
          comment: result.comment,
        });
      },
      error: () => {},
    });
  }
scanForAsset(file:any){
  let fileForScanAssets = this.uploadedFiles.find((i) => i.blobUrl == file.url);
  fileForScanAssets.isScanForAsset = file.isScanForAsset;
  this.emitResult();
}
}


// export const AllowedExtensions =
//   '.jpg,.jpeg,.png,.gif,.tiff,.mp4,.csv,.pdf,.eml,.msg,.mov';
export const EmailFileExtentions = '.msg,.eml';
